

export default class RICRevision {
    private _hwRevision: number = 1;

    public get hwRevision(): number {
        return this._hwRevision;
    }
    
    public set(flashSize: string) {
        // Handle RIC variants in the simplest way possible - using the Flash size as the discriminator
        this._hwRevision = 1;
        if (flashSize === "16MB") {
            this._hwRevision = 2;
        } else if (flashSize !== "4MB") {
            console.error(`Invalid FLASH size ${flashSize}`);
            return;
        }
    }
}
